// Routes for the proforma claims list, new, and edit screens.
import React from "react";

const ProformaClaimsIndex = React.lazy(() => import("./index"));
const ProformaClaimProject = React.lazy(() => import("./project"));
const NewProformaClaim = React.lazy(() => import("./new"));
const EditProformaClaim = React.lazy(() => import("./edit"));

export default [
  { path: "/administration/proforma_claims/project/:projectId", component: ProformaClaimProject, name: "Proforma Claim Project" },
  { path: "/administration/proforma_claims/:id/edit", component: EditProformaClaim, name: "Edit Proforma Claim" },
  { path: "/administration/proforma_claims/new", component: NewProformaClaim, name: "New Proforma Claim" },
  { path: "/administration/proforma_claims", component: ProformaClaimsIndex, name: "Proforma Claims" },
];
